import React from 'react';

const CreatePost: React.FC = () => (
  <div style={{ padding: '24px', maxWidth: '600px', margin: '0 auto' }}>
    <h1 style={{ color: '#fff', marginBottom: '16px' }}>Create post</h1>
    <p style={{ color: '#9ca3af' }}>Wire to POST /posts when backend app routes are ready.</p>
  </div>
);

export default CreatePost;
